<script lang="ts" setup>
  import type { EffortJsonldVueGlobalSearchDefaultReadSync } from '@/api'
  import ButtonRouter from '@/elements/ButtonRouter.vue'
  import type { RouteLocationRaw } from 'vue-router'

  interface Props {
    effort: EffortJsonldVueGlobalSearchDefaultReadSync
  }

  const props = defineProps<Props>()
  const emit = defineEmits<{
    buttonClicked: []
  }>()
  // const btnClass = 'rounded-md bg-white text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-gray-300 hover:bg-gray-300 w-full block p-2 h-full text-center whitespace-nowrap md:py-1'
  const shortcuts: Record<string, RouteLocationRaw> = props.effort.blocked
    ? {}
    : {
        Leistung: { name: 'effort_capture', query: { effort: props.effort.id } },
        'Time-Tracking': { name: 'time-tracking', query: { effort: props.effort.id } }
      }
</script>

<template>
  <div class="grid grid-cols-1 mt-1 flex-0 md:mt-0 w-full md:w-fit gap-y-1">
    <div
      v-for="(to, label) in shortcuts"
      :key="label">
      <ButtonRouter
        :label="$t(label)"
        :to="to"
        class="w-full"
        severity="info"
        size="small"
        @click.prevent="emit('buttonClicked')" />
    </div>
  </div>
  <!--
        <ul class="w-full mt-1 flex-0 md:mt-0 md:block md:w-fit">
            <li v-for="(to,label) in shortcuts" :key="label" class="flex-1 w-full py-0.5 last:pb-0 first:pt-0">
                <ButtonRouter
                    :to="to"
                    @click.prevent="emit('buttonClicked')"
                    :label="$t(label)"

                    xxxx-class="btnClass"
                />
            </li>
        </ul>-->
</template>

<style scoped></style>
